// ToolsContext.js
import React, { createContext, useContext, useState } from 'react';

const ToolsContext = createContext({
  toolStates: {},
  setToolState: () => {},
  closeSidebar: () => {},
});

const useToolsContext = () => useContext(ToolsContext);

export { ToolsContext, useToolsContext };
